import { NEWSLETTER_CUSTOM_ID } from '@/types/career/newsletter.types'

export const useMapDataNewsletter = () => {
  const config = useRuntimeConfig().public

  const getCustomId = (category: keyof typeof NEWSLETTER_CUSTOM_ID) => {
    try {
      return NEWSLETTER_CUSTOM_ID[category]
    } catch {
      console.error('INCORECT KEY', category)
      return ''
    }
  }

  const getCampaignToken = (campaignTokenName: string) => {
    try {
      return (config.getResponse as Record<any, any>)[campaignTokenName]
    } catch {
      console.error('INCORECT CAMPIAGN_NAME', campaignTokenName)
      return ''
    }
  }

  return {
    getCustomId,
    getCampaignToken,
  }
}
